<template>
    <div>
        <div class="sm:hidden">
            <label for="tabs" class="sr-only">Select a tab</label>
            <!-- Use an "onChange" listener to redirect the user to the selected tab URL. -->
            <select id="tabs" name="tabs" class="block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-light-pitch-purple sm:text-sm rounded-md">
                <option v-for="tab in tabs" :key="tab.name" :selected="tab.current">{{ tab.name }}</option>
            </select>
        </div>
        <div class="hidden sm:block">
            <div class="border-b border-gray-200">
                <nav class="-mb-px flex space-x-8" aria-label="Tabs">
                    <Link :preserve-state="false" :preserve-scroll="true" v-for="tab in tabs" :key="tab.name" :href="tab.href" :class="[$page.component.startsWith(tab.component) ? 'border-light-pitch-purple text-pitch-purple' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300', 'whitespace-nowrap py-4 px-1 border-b-2 text-sm']" :aria-current="tab.current ? 'page' : undefined">
                        {{ tab.name }}
                    </Link>
                </nav>
            </div>
        </div>
    </div>
</template>

<script>
import Authenticated from "@/Layouts/Authenticated.vue";
import SettingsLayout from "@/Layouts/SettingsLayout";
import {Link, usePage} from "@inertiajs/vue3";

// const tabs = [
//     { name: 'Clients', href: route('frontend.organisations.clients.index'), component: 'Frontend/Organisations/Clients' },
//     { name: 'Suppliers', href: route('frontend.organisations.suppliers.index'), component: 'Frontend/Organisations/Suppliers' },
//     { name: 'Groups', href: route('frontend.organisations.groups.index'), component: 'Frontend/Organisations/Groups' }
// ]

export default {
    components: {Link},
    computed: {
        tabs: () => usePage().props.tabs ?? null
    }
}
</script>
